// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'header';

export const Component = () => (
  <path d='M2.959 2h18.678c.239 0 .479.096.67.288a.946.946 0 0 1 .288.67V7.89H2V2.958c0-.24.096-.48.287-.67A.946.946 0 0 1 2.958 2Zm18.678 9.818v-2.97h.958v2.97h-.958Zm0 3.927v-2.97h.958v2.97h-.958Zm0 3.927v-2.97h.958v2.97h-.958Zm0 1.964V20.63h.958v1.006h-.958ZM2 11.818v-2.97h.958v2.97H2Zm0 3.927v-2.97h.958v2.97H2Zm0 3.927v-2.97h.958v2.97H2Zm0 1.964V20.63h.958v1.006H2Zm.959.958v-.958h2.97v.958h-2.97Zm3.926 0v-.958h2.97v.958h-2.97Zm3.928 0v-.958h2.969v.958h-2.97Zm3.927 0v-.958h2.97v.958h-2.97Zm3.927 0v-.958h2.97v.958h-2.97Z' />
);

export const viewBox = '0 0 25 25';
